module.exports = __webpack_public_path__ + "static/media/test10.8d674dcf.jpeg";